import {
    HttpClient,
    HttpErrorResponse,
    HttpParams
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { deleteVersion, mobileversionModel } from '../../models/AppVersion';
import { PromiseResult } from '../../models/PromiseResult';
import { PaginationModel } from '../../models/util.models';
import { RestApi } from '../../shared/apiUrls';

@Injectable({
    providedIn: 'root'
})
export class AppVersionService {
    constructor(private readonly http: HttpClient) {}

    private handleError(error: HttpErrorResponse) {
        return throwError(error);
    }

    fetchAll(body: PaginationModel): Observable<PromiseResult> {
        const params = new HttpParams()
            .append('page_no', body.page_no.toString())
            .append('records_per_page', body.records_per_page.toString());
        return this.http
            .get<PromiseResult>(
                RestApi.Urls.AppVersionApi + 'app/version/fetch',
                { params }
            )
            .pipe(catchError(this.handleError));
    }

    create(body: mobileversionModel): Observable<PromiseResult> {
        return this.http
            .post<PromiseResult>(
                RestApi.Urls.AppVersionApi + 'app/version/add',
                body
            )
            .pipe(catchError(this.handleError));
    }

    delete(body: deleteVersion): Observable<PromiseResult> {
        return this.http
            .put<PromiseResult>(
                RestApi.Urls.AppVersionApi + 'app/version/delete',
                body
            )
            .pipe(catchError(this.handleError));
    }
}
